import { cn } from "../../lib/utils";

interface ChipProps {
  label: string;
  color: "blue" | "orange" | "green" | "red" | "gray";
  variant?: "default" | "bordered";
  className?: string;
}

  const colorClasses: Record<string, string> = {
    blue: "text-blue-badge-text bg-blue-badge-background",
    orange: "text-orange-badge-text bg-orange-badge-background",
    green: "text-green-badge-text bg-green-badge-background",
    red: "text-red-badge-text bg-red-badge-background",
    gray: "text-gray-badge-text bg-gray-badge-background",
  };
  
  const borderClasses: Record<string, string> = {
    blue: "border border-blue-badge-border",
    orange: "border border-orange-badge-border",
    green: "border border-green-badge-border",
    red: "border border-red-badge-border",
    gray: "border border-gray-badge-border",
  };
  
  export const Chip = ({ label, color, variant = "default", className }: ChipProps) => {
    return (
      <div
        className={cn(
          "inline-flex items-center px-2 py-1 rounded-full text-sm font-medium",
          colorClasses[color],
          variant === "bordered" && borderClasses[color],
          className
        )}
      >
         <span className="size-1.5 rounded-full bg-current mr-1.5" /> {label}
    </div>
  );
};

export default Chip;
